import dayjs from "dayjs";

export const formatDate = (date: string | null, format: string = 'DD.MM.YYYY HH:mm') => {
    return date ? dayjs(date).format(format) : '';
}